import { hasCookie } from 'cookies-next'
import { useEffect, useState } from 'react'
import { MdClose } from 'react-icons/md'

import { useConsent } from 'src/providers/ConsentProvider/ConsentProvider'

import { ButtonRebrand } from 'src/components/atoms/ButtonRebrand'
import { IconButton } from 'src/components/atoms/IconButton'
import { InternalLink } from 'src/components/atoms/Link'
import { TypographyRebrand } from 'src/components/atoms/TypographyRebrand'

import { privacyPolicyPath } from 'src/config/paths'

export const ConsentBanner = () => {
  const [hideConsent, setHideConsent] = useState(true)
  const { allowCookies, denyCookies } = useConsent()

  useEffect(() => {
    const consentHidden =
      hasCookie('localConsent') ||
      sessionStorage.getItem('consent-dismissed') === 'true'
    setHideConsent(consentHidden)
  }, [])

  const handleAllowCookies = () => {
    setHideConsent(true)
    allowCookies()
  }

  const handleClosePopup = () => {
    sessionStorage.setItem('consent-dismissed', 'true')
    setHideConsent(true)
  }

  const handleDenyCookies = () => {
    setHideConsent(true)
    denyCookies()
  }

  if (hideConsent) return null

  return (
    <div
      className={`fixed w-full bottom-0 p-[30px] lg:px-[110px] lg:py-[30px] bg-limePale z-999 ${
        hideConsent ? 'hidden' : ''
      }`}
    >
      <div className='flex justify-between mb-5'>
        <TypographyRebrand variant='h5'>Cookies</TypographyRebrand>
        <div>
          <IconButton
            icon={MdClose}
            size='small'
            className='text-current'
            onClick={handleClosePopup}
            ariaLabel='Close consent'
          />
        </div>
      </div>
      <div className='flex flex-col xl:flex-row items-center justify-between gap-y-5'>
        <TypographyRebrand variant='body'>
          Trees That Count uses cookies to ensure the best experience on our
          website.{' '}
          <InternalLink href={privacyPolicyPath}>Learn more</InternalLink>.
        </TypographyRebrand>
        <div className='flex gap-x-[10px] justify-end mb-6'>
          <ButtonRebrand variant='outline' onClick={handleDenyCookies}>
            Deny all
          </ButtonRebrand>
          <ButtonRebrand variant='lime' onClick={handleAllowCookies}>
            Allow all
          </ButtonRebrand>
        </div>
      </div>
    </div>
  )
}
